import { combineReducers } from 'redux';

// Biuwer Maps reducers
import mapCatalog from "./map-catalog/map-catalog-reducer";

export default combineReducers({
    mapCatalog
});